import React from 'react'
import Styles from "../../Styles/interview.module.css"

function Upcoming() {
  return (
    <div className={Styles.intercontainer}>
      <div className={Styles.eventheader}>
       <h1>Date</h1>
       <h1>Venue</h1>
       <h1>Company</h1>
       <h1 className={Styles.move}>Time</h1>
       <h1>Meeting link</h1>
      </div>
      <div className={Styles.eventlist}>
       <p>21 Feb 2023</p>
       <p>Google Meet</p>
       <p className={Styles.move4}>Cdlp Hub Ltd</p>
       <p className={Styles.move2}>Cdlp Hub Ltd</p>
       <a className={Styles.move3} href="/">google meet</a>
      </div>
    </div>
  )
}

export default Upcoming;